"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Invoice = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var pluralize_1 = __importDefault(require("pluralize"));
var transactionV2_1 = require("../transaction/transactionV2");
var transaction_1 = require("../transaction/transaction");
var artifact_types_lang_1 = require("../../artifacts/artifact-types.lang");
var ui_common_1 = require("@codametrix/ui-common");
var Invoice = /** @class */ (function (_super) {
    __extends(Invoice, _super);
    function Invoice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Invoice.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, invoice = _b.simplifiedInvoice, panelActivations = _b.panelActivations, handleCodeChange = _b.handleCodeChange, handleCodeRemove = _b.handleCodeRemove, handleCodeSearchDrop = _b.handleCodeSearchDrop, onCodeSearch = _b.onCodeSearch, onCodeSearchSelection = _b.onCodeSearchSelection, onFeatureSelection = _b.onFeatureSelection, onChargeSessionAction = _b.onChargeSessionAction, editable = _b.editable;
        var transactions = invoice.transactions;
        var heading = (0, pluralize_1["default"])('Procedure', transactions.length);
        var billingArea = (_a = invoice.billing_area) !== null && _a !== void 0 ? _a : 'unspecified billing area';
        var billingProvider = invoice.billing_provider_name !== 'null'
            ? invoice.billing_provider_name
            : 'unspecified provider';
        var txnCount = 0;
        var txns = transactions.map(function (transaction, idx) {
            if (transaction.type !== 'SHARED_CODES') {
                txnCount += 1;
            }
            var TransactionComponent = _this.props.transactionV2
                ? transactionV2_1.TransactionV2
                : transaction_1.Transaction;
            var transactionProps = {
                onChargeSessionAction: onChargeSessionAction,
                panelActivations: panelActivations,
                handleCodeChange: handleCodeChange,
                handleCodeRemove: handleCodeRemove,
                handleCodeSearchDrop: handleCodeSearchDrop,
                onCodeSearch: onCodeSearch,
                onCodeSearchSelection: onCodeSearchSelection,
                onFeatureSelection: onFeatureSelection,
                lineNumber: txnCount,
                editable: editable,
                transaction: transaction
            };
            var tabContainerRef = (0, react_1.createRef)();
            //Only add scrollContainerRef if using TransactionV2
            var additionalProps = _this.props.transactionV2
                ? { scrollContainerRef: tabContainerRef }
                : {};
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "invoice-here" }, { children: (0, jsx_runtime_1.jsx)(TransactionComponent, __assign({}, additionalProps, transactionProps)) }), idx));
        });
        var invoiceStyleClasses = [
            'invoice',
            "invoice-type-".concat(invoice.type).toLowerCase(),
            {
                'invoice-no-transactions': transactions.length === 0,
                'invoice-no-billing-area': !invoice.billing_area
            }
        ];
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1["default"])(invoiceStyleClasses) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "invoice-provenance" }, { children: ui_common_1.objectUtils.get(artifact_types_lang_1.ArtifactTypes, invoice.type.toUpperCase(), invoice.type) })), (0, jsx_runtime_1.jsxs)("h4", __assign({ className: "invoice-heading" }, { children: [heading, " by ", billingProvider, (0, jsx_runtime_1.jsxs)("span", __assign({ className: "billing-area" }, { children: [" at ", billingArea] })), "."] })), txns, (0, jsx_runtime_1.jsx)("div", __assign({ className: "no-charges empty-message" }, { children: "No codes available." }))] })));
    };
    Invoice.displayName = 'Invoice';
    Invoice.defaultProps = {
        autoFocus: false,
        searchResults: [],
        editable: true,
        panelActivations: {},
        onChargeSessionAction: function (transactionAction) { },
        handleCodeChange: function (change) { },
        handleCodeRemove: function (change) { },
        handleCodeSearchDrop: function (change) { },
        onCodeSearch: function (codeQuery) { },
        onCodeSearchSelection: function (searchSelection) { },
        onFeatureSelection: function (feature) { }
    };
    return Invoice;
}(react_1["default"].Component));
exports.Invoice = Invoice;
//# sourceMappingURL=invoice.js.map